import React, { Component } from "react";
import { TableRow, TableRowColumn } from "material-ui/Table";
import styles from "styles";
import { Link } from "react-router";
import RaisedButton from "material-ui/RaisedButton";
import { connect } from "react-redux";
export class CompanyRow extends Component {
  render() {
    const {
      item: { name = "-", emails = [], members = [], owner = {}, apiList = [] },
      integratorId,
    } = this.props;
    return (
      <TableRow>
        <TableRowColumn style={styles.tableRowBordered}>
          {emails.map((email) => (
            <p key={email}>{email}</p>
          ))}
        </TableRowColumn>
        <TableRowColumn style={styles.tableRowBordered}>{name}</TableRowColumn>
        <TableRowColumn style={styles.tableRowBordered}>
          {owner.name}
        </TableRowColumn>
        <TableRowColumn style={styles.tableRowBordered}>
          <Link
            to={`/integrators/${integratorId}/user/${owner._id}`}
            key={owner._id}
          >
            {owner.email}
          </Link>
        </TableRowColumn>
        <TableRowColumn style={styles.tableRowBordered}>
          {members.map((member) => (
            <div key={member._id}>
              <Link
                to={`/integrators/${integratorId}/user/${member._id}`}
                key={member._id}
              >
                {member.email}
              </Link>
              <br />
            </div>
          ))}
        </TableRowColumn>
        {/* <TableRowColumn style={styles.tableRowBordered}>
          <div
            style={{
              display: "flex",
              flexWrap: "wrap",
              justifyContent: "space-between",
            }}
          >
            <RaisedButton
              buttonStyle={styles.greenBtn}
              labelStyle={{ color: "#fff" }}
              label="Active"
            ></RaisedButton>
            <RaisedButton label="Disabled"></RaisedButton>
          </div>
        </TableRowColumn> */}
        <TableRowColumn style={styles.tableRowBordered}>
          {apiList.map((api) => (
            <p key={api.name}>
              {api.name} - {api.used}
            </p>
          ))}
        </TableRowColumn>
      </TableRow>
    );
  }
}

export default connect(
  ({ integratorCompanies: { integratorId } }) => ({ integratorId }),
  null
)(CompanyRow);



// WEBPACK FOOTER //
// ./app/components/Integrators/Companies/CompanyRow.jsx